import Tr from 'translations/Translations';

const createItem = (value) => ({label: Tr('pzp_exclusion.' + value), value})

export default [
    {label: '---', value: ''},
    createItem('exclusion13'),
    createItem('exclusion16'),
    createItem('exclusion10'),
    createItem('exclusion1'),
    createItem('exclusion2'),
    createItem('exclusion3'),
    createItem('exclusion4'),
    createItem('exclusion5'),
    createItem('exclusion6'),
    createItem('exclusion7'),
    createItem('exclusion8'),
    createItem('exclusion9'),
    createItem('exclusion11'),
    createItem('exclusion12'),
    createItem('exclusion14'),
    createItem('exclusion15'),
]